import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { attachmentService } from "../../services/attachment.service";

export const listAttachmentByMessageId = createAsyncThunk(
  "attachmentManage/listAttachmentByMessageId",
  async (messageId, { rejectWithValue }) => {
    try {
      const response = await attachmentService.listAttachmentByMessageId(
        messageId
      );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const queryAttachmentBySessionId = createAsyncThunk(
  "attachmentManage/queryAttachmentBySessionId",
  async ({ sessionId, filter }, { rejectWithValue }) => {
    try {
      const response = await attachmentService.queryAttachmentBySessionId(
        sessionId,
        filter
      );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
